<script>
  export let value
  export let label
</script>

<label class="text-sm text-sky-primary cursor-pointer flex items-center mb-0 leading-9">
  <input class="styled-checkbox flex-grow-0" type="checkbox" bind:checked={value} />
  <span class="flex-grow select-none">{label}</span>
</label>
